<template>
  <a-menu
    v-model="langMenu"
    offset-y
    close-on-content-click
    dense
    nudge-bottom="2"
  >
    <template v-slot:activator="{ on, attrs }">
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }"> -->
      <a-btn class="ma-2" color="secondary" v-bind="attrs" v-on="on" small>
        {{ selectedText }}
        <v-icon v-if="langMenu" size="20" class="ml-2" color="neutralGray"
          >mdi-chevron-up</v-icon
        >
        <v-icon v-else class="ml-2" size="20" color="neutralGray"
          >mdi-chevron-down</v-icon
        >
      </a-btn>
      <!-- </template>
        <span>Select signer</span>
      </v-tooltip> -->
    </template>
    <v-list dense>
      <v-list-item-group :value="selectedValue">
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :value="item.value"
          @click="onSelectionChange(item)"
        >
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </a-menu>
</template>

<script>
export default {
  name: "SignLanguage",
  props: {
    value: String,
    items: Array,
  },
  data() {
    return {
      selectedLocale: "日本語",
      langMenu: false,
    };
  },
  computed: {
    selectedValue() {
      return this.value;
    },
    selectedText() {
      return this.getSelectedText(this.value);
    },
  },
  methods: {
    getSelectedText,
    onSelectionChange,
  },
};

function onSelectionChange(lang) {
  this.$emit("input", lang.value);
}

function getSelectedText(value) {
  const data = this.items.find((l) => l.value === value);
  return data ? data.text : "";
}
</script>

<style>
</style>